import axios from 'src/api';
import { NotificationManager } from 'react-notifications';
import {
  _getAPICode,
  _createAPICode,
  _updateAPICode,
  _updateAPICodeStatus
} from 'src/api/KeyManagerRequest';
import { GETAPI_SUCCESS } from '../types';

export const getAPICodeData = () => {
  return async (dispatch) => {
    try {
      const { data } = await _getAPICode();
      if (data.error.status == 1) {
        NotificationManager.error(data.error.message, 'Error');
        return -1;
      }
      dispatch({ type: GETAPI_SUCCESS, payload: data.content });
      // NotificationManager.success("API Code", 'Success');
      return 1;
    } catch (error) {
      console.log('error', error);
      NotificationManager.error(error.message, 'Error');
      return -1;
    }
  };
};

export const createAPICode = (obj) => {
  return async (dispatch) => {
    try {
      const reqObj = {
        data: {
          name: obj.name,
          userID: obj.userid,
          usersecret: obj.usersecret
        }
      };

      const { data } = await _createAPICode(reqObj);

      if (data.error.status == 1) {
        NotificationManager.error(data.error.message, 'Error');
        return -1;
      }
      dispatch(getAPICodeData());
      //   dispatch({ type: SIGNIN_SUCCESS, payload: data.content });
      NotificationManager.success('API Key created successfully', 'Success');
      return 1;
    } catch (error) {
      console.log('error', error);
      NotificationManager.error(error.message, 'Error');
      return -1;
    }
  };
};

export const updateAPICode = (obj) => {
  return async (dispatch) => {
    try {
      const reqObj = {
        data: {
          name: obj.name,
          userID: obj.userid,
          usersecret: obj.usersecret || null,
          id: obj.id
        }
      };

      const { data } = await _updateAPICode(reqObj);

      if (data.error.status == 1) {
        NotificationManager.error(data.error.message, 'Error');
        return -1;
      }
      dispatch(getAPICodeData());
      NotificationManager.success('API Key updated successfully', 'Success');
      return 1;
    } catch (error) {
      console.log('error', error);
      NotificationManager.error(error.message, 'Error');
      return -1;
    }
  };
};

export const updateAPICodeStatus = (obj) => {
  return async (dispatch) => {
    try {
      const reqObj = {
        data: {
          status: obj.status,
          userID: obj.userid,
          id: obj.id
        }
      };
      const { data } = await _updateAPICodeStatus(reqObj);
      if (data.error.status == 1) {
        NotificationManager.error(data.error.message, 'Error');
        return -1;
      }
      dispatch(getAPICodeData());
      NotificationManager.success(
        'API Key Status updated successfully',
        'Success'
      );
      return 1;
    } catch (error) {
      console.log('error', error);
      NotificationManager.error(error.message, 'Error');
      return -1;
    }
  };
};
